<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { commonService } from "@/services/common";
import { userService } from "@/services/authservice/user";
import { customerService } from "@/services/authservice/customer";
import TableLoading from "@/components/ipos/table-loading";
import { itemGroupService } from "@/services/authservice/item-group";
import { itemService } from "@/services/authservice/item";
import { inventoryService } from "@/services/authservice/inventory";
import UtilsMixin from "@/mixins/utils";
import PrintExport from "@/components/ipos/print-export";
import DatePicker from "vue2-datepicker";

export default {
  page: {
    title: "Chi tiết phiếu xuất",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin],
  components: { TableLoading, Layout, PageHeader, PrintExport,DatePicker },
  data() {
    return {
      title: "Chi tiết phiếu xuất",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Xuất hàng",
          href: "/inventory/export",
        },
        {
          text: "Chi tiết phiếu xuất",
          active: true,
        },
      ],
      listProductAll: [],
      listProductByGroup: [],
      listProduct: [],
      listProductGroup: [],
      listUser: [],
      listCustomer: [],
      listCustomerStore: [],
      dataDetail: {},
      selected: "all",
      selectedItem: [],
      listRegion: [],
      listWarehouse: [],
      listAgency: [],
      formData: {
        note: "",
      },
      totalAmount: "",
      keyword: "",
      me: {},
      isBusy: true,
      isBtnCancel: false,
      isBtnUpdate: false,
      distributorInfo: {},
    };
  },

  methods: {
    async getInitData() {
      this.isBusy = true;
      console.log(this.me);
      const customerPromise = customerService.getListCustomer();
      const shipperPromise = userService.getListUser({ role_id: "SHIPPER" });
      const agencyPromise = userService.getListUser({ role_id: "AGENCY" });
      const regionPromise = commonService.getListRegion();
      const warehousePromise = commonService.getListWarehouse();
      const unitPromise = commonService.getListUnit();
      const itemGroupPromise = itemGroupService.getList();
      const distributorPromise = commonService.getDistributorInfo({
        uid: this.me.distributor_uid,
      });
      const itemPromise = itemService.getList({ active: 1 });
      const giPromise = inventoryService.getListGoodsIssue({
        uid: this.$route.params.id,
      });
      const customerStorePromise = customerService.getListCustomerStore();
      // get list customer
      const resCus = await customerPromise;
      if (resCus.data.error) {
        this.listCustomer = [];
      } else {
        this.listCustomer = resCus.data.data;
      }
      // get list shipper
      const resUser = await shipperPromise;
      if (resUser.data.error) {
        this.listUser = [];
      } else {
        this.listUser = resUser.data.data;
      }
      // get list agency
      const resAgency = await agencyPromise;
      if (resAgency.data.error) {
        this.listAgency = [];
      } else {
        this.listAgency = resAgency.data.data;
      }
      // get list region
      const responseRegion = await regionPromise;
      if (responseRegion.data.error) {
        this.listRegion = {};
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: responseRegion.data.error.message,
        });
      } else {
        this.listRegion = responseRegion.data.data;
      }
      // get list warehouse
      const resWH = await warehousePromise;
      if (resWH.data.error) {
        this.listWarehouse = {};
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: resWH.data.error.message,
        });
      } else {
        this.listWarehouse = resWH.data.data;
      }
      // get list unit
      const resUnit = await unitPromise;
      this.listUnit = resUnit.data.data;
      const resGroup = await itemGroupPromise;
      if (resGroup.data.error) {
        this.listProductGroup = {};
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: resGroup.data.error.message,
        });
      } else {
        this.listProductGroup = resGroup.data.data;
      }
      const resDistri = await distributorPromise;
      this.distributorInfo = resDistri.data.data;

      const resItem = await itemPromise;
      if (resItem.data.error) {
        this.listProductAll = [];
        this.listProductByGroup = [];
        this.listProduct = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: resItem.data.error.message,
        });
      } else {
        this.listProductAll = resItem.data.data;
        this.listProductByGroup = resItem.data.data;
        this.listProduct = resItem.data.data;
      }
      // get data detail
      const response = await giPromise;
      if (response.data.error) {
        this.dataDetail = {};
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: response.data.error.message,
        });
      } else {
        this.dataDetail = response.data.data;
        if(this.dataDetail.gi_type === 'XKM' && this.dataDetail.status === 'CONFIRMED') this.dataDetail.gi_time = new Date();
        this.title = `Chi tiết phiếu xuất ${response.data.data.gi_id}`;
        // get list customer
        const resCusStore = await customerStorePromise;
        if (resCusStore.data.error) {
          this.listCustomerStore = [];
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: resCusStore.data.error.message,
          });
        } else {
          this.listCustomerStore = resCusStore.data.data;
        }
        this.selectedItem = response.data.data.details;
        this.totalAmount = response.data.data.amount;
      }
      this.isBusy = false;
    },

    renderUnit(id) {
      const find = this.listUnit.filter((e) => e.id === id);
      return find[0].unit_name;
    },

    onChangeSKU(value, id) {
      this.selectedItem = this.selectedItem.map((obj) => {
        if (obj.id === id) {
          if (value !== null && value !== undefined && value !== "") {
            return { ...obj, ids_sku: value };
          }
        }
        return obj;
      });
    },

    onChangeQuantity(value, id) {
      this.selectedItem = this.selectedItem.map((obj) => {
        if (obj.id === id) {
          if (value >= 0) {
            return { ...obj, export_qty: this.parseCurrency(value) };
          }
        }
        return obj;
      });
    },

    onChangePrice(value, id) {
      this.selectedItem = this.selectedItem.map((obj) => {
        if (obj.id === id) {
          if (value >= 0) {
            return {
              ...obj,
              price: this.parseCurrency(value),
            };
          }
        }
        return obj;
      });
    },

    async onUpdateGI() {
      const details = this.selectedItem.map((e) => {
        return {
          sku: e.sku,
          item_name: e.item_name,
          unit_id: e.unit_id,
          unit_name: e.unit_name,
          export_qty: e.export_qty,
          price: e.price,
          vat: 0.0,
          amount: e.price * e.export_qty,
        };
      });
      const body = {
        id: this.dataDetail.id,
        note: this.formData.note,
        details: details,
      };

      this.isBtnUpdate = true;
      const res = await inventoryService.updateGoodsIssue(body);
      if (res.data.error) {
        this.$notify({
          group: "app",
          type: "error",
          title: "Cập nhật lỗi",
          text: res.data.error.message,
        });
      } else {
        this.$notify({
          group: "app",
          type: "success",
          title: "Cập nhật thành công",
        });
        this.$router.push({ path: "/inventory/export" });
      }
      this.isBtnUpdate = false;
    },

    async onCompleteGI() {
      const body = {
        id: this.dataDetail.id,
        note: this.formData.note,
        status: "COMPLETED",
        gi_time: this.dataDetail.gi_time.getTime()
      };
      this.isBtnUpdate = true;
      const res = await inventoryService.updateGoodsIssue(body);
      if (res.data.error) {
        this.$notify({
          group: "app",
          type: "error",
          title: "Cập nhật lỗi",
          text: res.data.error.message,
        });
      } else {
        this.$notify({
          group: "app",
          type: "success",
          title: "Cập nhật thành công",
        });
        this.$router.push({ path: "/inventory/export" });
      }
      this.isBtnUpdate = false;
    },

    onPrint() {
      this.$htmlToPaper("exportPrint", null, async () => {});
    },

    hideModal() {
      this.$bvModal.hide("md-cancel-order");
    },

    showModel() {
      this.$bvModal.show("md-cancel-order");
    },

    async onCancelGI() {
      this.isBtnCancel = true;
      const res = await inventoryService.updateGoodsIssue({
        id: this.dataDetail.id,
        status: "CANCELED",
        note: this.formData.note,
      });
      if (res.data.error) {
        this.$notify({
          group: "app",
          type: "error",
          title: "Huỷ phiếu thất bại",
          text: "Vui lòng kiểm tra lại thông tin",
        });
      } else {
        this.$notify({
          group: "app",
          type: "success",
          title: "Huỷ phiếu thành công",
        });
        this.hideModal();
        this.$router.push(`/inventory/export?tab=${this.dataDetail.gi_type}`);
      }
      this.isBtnCancel = false;
    },
  },

  watch: {
    "$route.query": {
      handler: function () {
        this.title = "Chi tiết phiếu xuất";
        this.me = JSON.parse(localStorage.getItem("user"));
        this.getInitData();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-2">
      <div class="col-lg-12">
        <div class="d-flex align-content-center justify-content-end">
          <button @click="onPrint" type="button" class="btn btn-light ml-2">
            <i class="bx bx-printer font-size-16 align-middle mr-2"></i> In
            phiếu
          </button>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left: -5px; margin-right: -5px">
      <div
        class="col-lg-4 col-md-12 col-sm-12 mb-2"
        style="padding-left: 5px; padding-right: 5px"
      >
        <div class="bg-white box-shadow" style="border: 1px solid #eff2f7">
          <TableLoading v-if="isBusy" />
          <template v-else>
            <!-- Xuất bán hàng -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XBH'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho hàng" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Khách hàng" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.export_to_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Tham chiếu" class="w150">
                    <router-link
                      target="_blank"
                      class="custom-detail-input"
                      :to="{
                        name: 'OrderDetail',
                        params: {
                          id: dataDetail.reference_info[0].document_uid,
                        },
                      }"
                    >
                      <div class="mb-0">
                        {{ dataDetail.reference_info[0].document_id }}
                      </div>
                    </router-link>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Người nhận" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${dataDetail.delivery_info.contact_name} - ${dataDetail.delivery_info.contact_phone}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Đ/C nhận" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="dataDetail.delivery_info.delivery_address"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Người giao" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${dataDetail.shipper_name} - ${dataDetail.shipper_phone}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-textarea
                        :disabled="true"
                        type="text"
                        v-model="dataDetail.note"
                        max-rows="6"
                    ></b-textarea>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất Salesman -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XSM'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Salesman" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.export_to_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Tham chiếu" class="w150">
                    <router-link
                      target="_blank"
                      class="custom-detail-input"
                      :to="{
                        name: 'OrderDetail',
                        params: {
                          id: dataDetail.reference_info[0].document_uid,
                        },
                      }"
                    >
                      <div class="mb-0">
                        {{ dataDetail.reference_info[0].document_id }}
                      </div>
                    </router-link>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-textarea
                        :disabled="true"
                        type="text"
                        v-model="dataDetail.note"
                        max-rows="6"
                    ></b-textarea>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất trưng bày -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XTB'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho hàng" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Salesman" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.export_to_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-textarea
                        :disabled="true"
                        type="text"
                        v-model="dataDetail.note"
                        max-rows="6"
                    ></b-textarea>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất khuyến mãi -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XKM'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Salesman" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.export_to_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Tham chiếu" class="w150">
                    <router-link
                      target="_blank"
                      class="custom-detail-input"
                      :to="{
                        name: 'OrderDetail',
                        params: {
                          id: dataDetail.reference_info[0].document_uid,
                        },
                      }"
                    >
                      <div class="mb-0">
                        {{ dataDetail.reference_info[0].document_id }}
                      </div>
                    </router-link>
                  </b-input-group>
                </div>
                <div v-if="dataDetail.status === 'CONFIRMED'" class="d-flex mtn1">
                  <div class="custom-input-group w150">Thời gian xuất</div>
                  <date-picker
                      type="datetime"
                      id="giTime"
                      v-model="dataDetail.gi_time"
                      :first-day-of-week="1"
                      lang="vi"
                      format="DD/MM/YYYY HH:mm"
                      placeholder="Chọn thời gian"
                      class="custom-datepicker"
                  ></date-picker>
                </div>
                <div v-else class="d-flex mtn1">
                  <b-input-group prepend="Thời gian tạo" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>
             
                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian tạo" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.created_at)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-textarea
                        :disabled="true"
                        type="text"
                        v-model="dataDetail.note"
                        max-rows="6"
                    ></b-textarea>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất điều chỉnh -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XDC'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Tham chiếu" class="w150">
                    <router-link
                      target="_blank"
                      class="custom-detail-input"
                      :to="{
                        name: 'InventoryCheckDetail',
                        params: {
                          id: dataDetail.reference_info[0].document_uid,
                        },
                      }"
                    >
                      <div class="mb-0">
                        {{ dataDetail.reference_info[0].document_id }}
                      </div>
                    </router-link>
                  </b-input-group>
                </div>
                <div class="d-flex pt-3">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>

                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian tạo" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.created_at)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Người tạo" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${dataDetail.created_by}`"
                    ></b-input>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất điều chuyển nội bộ -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XNB'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      v-model="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Kho nhập" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      v-model="dataDetail.export_to_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Tham chiếu" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      v-model="dataDetail.reference_info[0].document_id"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Người nhận" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${dataDetail.delivery_info.contact_name} - ${dataDetail.delivery_info.contact_phone}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Đ/C nhận" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="dataDetail.delivery_info.delivery_address"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Người giao" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${dataDetail.shipper_name} - ${dataDetail.shipper_phone}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-textarea
                        :disabled="true"
                        type="text"
                        v-model="dataDetail.note"
                        max-rows="6"
                    ></b-textarea>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất trả lại -->
            <div class="bg-white p-3" v-if="dataDetail.gi_type === 'XTL'">
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1" v-if="dataDetail.trademark">
                  <b-input-group prepend="Nhãn hàng" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      id="phone"
                      v-model="dataDetail.trademark.trademark_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>

                <div class="d-flex mtn1">
                  <b-input-group prepend="Tham chiếu" class="w150">
                    <router-link
                      target="_blank"
                      class="custom-detail-input"
                      :to="{
                        name: 'InventoryImportDetail',
                        params: {
                          id: dataDetail.reference_info[0].document_uid,
                        },
                      }"
                    >
                      <div class="mb-0">
                        {{ dataDetail.reference_info[0].document_id }}
                      </div>
                    </router-link>
                  </b-input-group>
                </div>

                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="dataDetail.note"
                    ></b-input>
                  </b-input-group>
                </div>
              </div>
            </div>
            <!-- Xuất huỷ + xuất khác -->
            <div
              class="bg-white p-3"
              v-if="
                dataDetail.gi_type === 'XHH' || dataDetail.gi_type === 'XKK'
              "
            >
              <div class="input-no-br">
                <div class="d-flex">
                  <b-input-group prepend="Kho xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      v-model="dataDetail.warehouse.warehouse_name"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Ghi chú" class="w150">
                    <b-textarea
                        :disabled="true"
                        type="text"
                        v-model="dataDetail.note"
                        max-rows="6"
                    ></b-textarea>
                  </b-input-group>
                </div>

                <div class="d-flex pt-3">
                  <b-input-group prepend="Thời gian xuất" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.gi_time)}`"
                    ></b-input>
                  </b-input-group>
                </div>

                <div class="d-flex mtn1">
                  <b-input-group prepend="Thời gian tạo" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${formatDateUnix(dataDetail.created_at)}`"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Người tạo" class="w150">
                    <b-input
                      :disabled="true"
                      type="text"
                      :value="`${dataDetail.created_by}`"
                    ></b-input>
                  </b-input-group>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div
        class="col-lg-8 col-md-12 col-sm-12 mb-2"
        style="padding-left: 5px; padding-right: 5px"
      >
        <div class="table-responsive table-responsive-order-detail mb-2 bg-white box-shadow">
          <TableLoading v-if="isBusy" />
          <table class="table table-bordered scroll-table" v-else>
            <thead>
              <tr>
                <th scope="col" class="min-w-140">Mã</th>
                <th scope="col" class="min-w-120">
                  Hàng hoá
                  {{
                    selectedItem.length > 0 ? `(${selectedItem.length})` : ""
                  }}
                </th>
                <th scope="col">SL</th>
                <th scope="col">ĐVT</th>
                <th scope="col" class="min-w-100">Giá</th>
                <th scope="col" class="min-w-100">Giảm giá</th>
                <th scope="col" class="min-w-75">VAT (%)</th>
                <th scope="col" class="min-w-100">Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in selectedItem" :key="item.id">
                <td>{{ item.sku }}</td>
                <td>{{ item.item_name }}</td>
                <td>
                  <template
                    v-if="
                      dataDetail.gi_type === 'XNB' &&
                      dataDetail.status === 'PENDING'
                    "
                  >
                    <b-input-group class="sm-group">
                      <b-input
                        class="w10 text-center"
                        @input="onChangeQuantity($event, item.id)"
                        type="text"
                        :value="item.export_qty"
                      ></b-input>
                    </b-input-group>
                  </template>
                  <template v-else>{{ item.export_qty }}</template>
                </td>
                <td>{{ item.unit_name }}</td>
                <td>
                  <template
                    v-if="
                      dataDetail.gi_type === 'XNB' &&
                      dataDetail.status === 'PENDING'
                    "
                  >
                    <b-input-group class="sm-group">
                      <b-input
                        class="text-center"
                        @input="onChangePrice($event, item.id)"
                        type="text"
                        :value="item.price"
                      ></b-input>
                    </b-input-group>
                  </template>
                  <template v-else>{{ formatPrice(item.price) }}</template>
                </td>
                <td>{{ formatPrice(item.discount_amount) }}</td>
                <td>{{ item.vat }}</td>
                <td>{{ calculateAmount(item, "export_qty") }}</td>
              </tr>
              <tr v-if="selectedItem.length === 0">
                <td colspan="6">
                  <p class="p-3 m-0 text-center">Chưa chọn hàng hoá</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive mb-0 bg-white box-shadow">
          <TableLoading v-if="isBusy" />
          <div v-else class="p-3" style="border: 1px solid #eff2f7">
            <div class="d-flex align-content-center justify-content-between">
              <p class="font-weight-bold mb-0">Tổng tiền</p>
              <p class="font-weight-bold mb-0">
                {{
                  formatPrice(
                    calculateTotalAmount(
                      selectedItem,
                      "FINAL_AMOUNT",
                      "export_qty"
                    )
                  )
                }}đ
              </p>
            </div>
            <div
              class="mt-3 d-flex align-content-center justify-content-between"
            >
              <b-input
                type="text"
                id="note"
                v-model="formData.note"
                placeholder="Ghi chú (nếu có)"
                :disabled="dataDetail.status === 'COMPLETED' || dataDetail.status === 'CANCELED'"
              ></b-input>
            </div>
            <div
              class="mt-3 d-flex align-content-center justify-content-end"
              v-if="
                (dataDetail.gi_type === 'XNB' &&
                  dataDetail.status === 'PENDING') ||
                dataDetail.gi_type === 'XTL' ||
                dataDetail.gi_type === 'XHH' ||
                dataDetail.gi_type === 'XKK' ||
               
                (dataDetail.gi_type === 'XKM' &&
                  dataDetail.status === 'CONFIRMED') ||
                (dataDetail.gi_type === 'XTB' &&
                  dataDetail.status === 'CONFIRMED')
              "
            >
             <!-- (dataDetail.gi_type === 'XSM' &&
                  dataDetail.status === 'CONFIRMED') || -->
              <button
                class="btn btn-danger d-block w150"
                @click="showModel()"
                :disabled="isBtnCancel || isBtnUpdate"
              >
                <template v-if="isBtnCancel">
                  <i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Đang xử
                  lý...
                </template>
                <template v-else>Huỷ phiếu</template>
              </button>
              <button
                v-if="
                  dataDetail.gi_type === 'XNB' &&
                  dataDetail.status === 'PENDING'
                "
                class="ml-2 btn btn-primary d-block w150"
                @click="onUpdateGI()"
                :disabled="isBtnUpdate || isBtnCancel"
              >
                <template v-if="isBtnUpdate">
                  <i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Đang xử
                  lý...
                </template>
                <template v-else>Cập nhật</template>
              </button>
              <button
                v-if="
                  dataDetail.gi_type === 'XKM' &&
                  dataDetail.status === 'CONFIRMED'
                "
                class="ml-2 btn btn-primary d-block w150"
                @click="onCompleteGI()"
                :disabled="isBtnUpdate || isBtnCancel"
              >
                <template v-if="isBtnUpdate">
                  <i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Đang xử
                  lý...
                </template>
                <template v-else>Xuất kho</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  Print container  -->
    <div id="exportPrint" class="bg-white p-3 text-dark d-none" v-if="!isBusy">
      <PrintExport :data="dataDetail" :me="me" :distributor="distributorInfo" />
    </div>

    <!-- Xác nhận tiếp tục hủy phiếu xuất -->
    <b-modal
      id="md-cancel-order"
      title="Xác nhận hủy phiếu xuất"
      centered
      hide-footer
    >
      <p>
        Bạn có chắc chắn muốn hủy phiếu xuất
        <b>{{ this.dataDetail.gi_id }}</b> không ?
      </p>
      <footer class="modal-footer px-0 pb-0">
        <button type="button" class="btn btn-secondary" @click="hideModal">
          Quay lại
        </button>
        <button
          type="button"
          class="btn btn btn-danger"
          :disabled="isBtnCancel"
          @click="onCancelGI"
        >
          <template v-if="isBtnCancel">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-1"></i>
            Đang xử lý...
          </template>
          <template v-else>Hủy phiếu</template>
        </button>
      </footer>
    </b-modal>
  </Layout>
</template>